import { ArrowLeftIcon, ArrowRightIcon } from '../../svg'
import { cn } from '../../utils'
import { useMemo } from 'react'
import Select from 'react-select'
import { getPickerHeader } from './DatePicker.styles'
import { getSelectStyles } from './styles'
import { DatePickerHeaderProps } from './types'

/**
 *
 * @param date - Date object
 * @param decreaseMonth - Callback function to decrease the month
 * @param increaseMonth - Callback function to increase the month
 * @param className - className for the DatePicker header
 * @param changeMonth - Callback function to change the month
 * @param changeYear - Callback function to change the year
 */

export const DatePickerHeader = ({
    date,
    decreaseMonth,
    increaseMonth,
    changeMonth,
    changeYear,
    className,
    t,
}: DatePickerHeaderProps) => {
    const currentMonth: number = date.getMonth()
    const currentYear = date.getFullYear()

    const months = (t: DatePickerHeaderProps['t']): string[] => [
        t('shared:months.january'),
        t('shared:months.february'),
        t('shared:months.march'),
        t('shared:months.april'),
        t('shared:months.may'),
        t('shared:months.june'),
        t('shared:months.july'),
        t('shared:months.august'),
        t('shared:months.september'),
        t('shared:months.october'),
        t('shared:months.november'),
        t('shared:months.december'),
    ]

    const years = useMemo(() => {
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const years = []
        // Include more future years for competition end dates
        for (let year = currentYear + 10; year >= 1900; year--) {
            years.push({ label: year.toString(), value: year })
        }
        return years
    }, [])

    const monthOptions = useMemo(() => {
        return months(t).map((month, index) => ({ label: month, value: index }))
    }, [t])

    return (
        <div className={cn(getPickerHeader(), className)}>
            <span onClick={decreaseMonth} className="cursor-pointer">
                <ArrowLeftIcon />
            </span>
            <div className="flex items-center">
                <Select
                    classNamePrefix="month-select"
                    value={monthOptions[currentMonth]}
                    onChange={(option) => {
                        if (option) {
                            changeMonth(option.value)
                        }
                    }}
                    options={monthOptions}
                    isSearchable={true}
                    menuPlacement="auto"
                    styles={getSelectStyles('100px')}
                />

                <Select
                    classNamePrefix="year-select"
                    value={years.find((option) => option.value === currentYear)}
                    onChange={(option) => {
                        if (option) {
                            changeYear(option.value)
                        }
                    }}
                    options={years}
                    isSearchable={true}
                    menuPlacement="auto"
                    styles={getSelectStyles('60px')}
                />
            </div>
            <span onClick={increaseMonth} className="cursor-pointer">
                <ArrowRightIcon />
            </span>
        </div>
    )
}
